import { Card } from '@eventbrite/eds-card';
import { Trending as TrendingSvg } from '@eventbrite/eds-iconography';
import {
    GRID_TYPE,
    MediaCardContent,
    STANDARD_STYLE,
} from '@eventbrite/eds-media-card-content';
import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { BucketHeader } from '../../../../components/BucketHeader';
import { SeeMoreButton } from '../../../../components/SeeMoreButton';
import {
    GA_CITY_BROWSE_CATEGORY,
    GA_VIEW_ALL_TRENDING_SEARCHES_ACTION,
    GA_VIEW_TRENDING_SEARCH_ACTION,
} from '../../../../constants/analytics';
import { getTrendingSearchesPathForLocation } from '../../../../utils/trending';

type Content = {
    id: number;
    searchTerm: string;
    searchPath: string;
}[];

interface TrendingSearchesBucketProps {
    currentPlace: string;
    content: Content;
    name: string;
    httpReferer: string;
    locationSlug?: string;
    trackGAEvent: Function;
    trackGAEventOnPageUnload: Function;
    seeMoreMarkedNoFollow?: boolean;
}

const _formattedTitle = (id: number, searchTerm: string) => (
    <span className="eds-text-bl eds-text-weight--regular eds-text-bm eds-text-color--ui-blue">
        {id + 1}. {upperFirst(searchTerm)}
    </span>
);

const _getTrendingSearchCards = (content: Content, trackClick: Function) => {
    const classes =
        'eds-l-pad-hor-3 eds-l-pad-vert-2 eds-g-cell eds-g-cell-md-3-12 eds-g-cell-12-12';

    return content.map(({ id, searchTerm, searchPath }) => (
        <div key={id} className={classes}>
            <Card style="simple">
                <MediaCardContent
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={searchPath}
                    title={_formattedTitle(id, searchTerm)}
                    onClick={trackClick.bind(this, searchTerm)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

const _handleSeeMoreClick = (
    currentPlace: string,
    trackGAEventOnPageUnload: Function,
    _urlObject: { url: string },
    action: string,
) => {
    trackGAEventOnPageUnload({
        category: GA_CITY_BROWSE_CATEGORY,
        action,
        label: currentPlace,
    });
};

const _handleSelectSearchClick: any = (
    trackGAEvent: Function,
    searchTerm: string,
) => {
    trackGAEvent({
        category: GA_CITY_BROWSE_CATEGORY,
        action: GA_VIEW_TRENDING_SEARCH_ACTION,
        label: searchTerm,
        requestPath: window.location.pathname,
    });
};

export class TrendingSearchesBucket extends React.PureComponent<TrendingSearchesBucketProps> {
    render() {
        const {
            currentPlace,
            content,
            name,
            locationSlug,
            trackGAEvent,
            trackGAEventOnPageUnload,
            seeMoreMarkedNoFollow = false,
        } = this.props;
        const trendingSearchesPath =
            getTrendingSearchesPathForLocation(locationSlug);

        return (
            <div>
                <BucketHeader
                    title={name}
                    iconType={<TrendingSvg />}
                    linkUrl={trendingSearchesPath}
                    template="trending_searches"
                    trackSeeMore={_handleSeeMoreClick.bind(
                        null,
                        currentPlace,
                        trackGAEventOnPageUnload,
                        { url: trendingSearchesPath },
                    )}
                    trackGAEvent={trackGAEvent}
                    gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                    seeMoreMarkedNoFollow={seeMoreMarkedNoFollow}
                />
                <div className="eds-g-group">
                    {_getTrendingSearchCards(
                        content,
                        _handleSelectSearchClick.bind(null, trackGAEvent),
                    )}
                </div>
                <div className="eds-l-pad-top-6">
                    <div className="eds-show-down-sn eds-align--center">
                        <div className="eds-g-cell">
                            <SeeMoreButton
                                linkUrl={trendingSearchesPath}
                                title={name}
                                trackClick={_handleSeeMoreClick.bind(
                                    null,
                                    currentPlace,
                                    trackGAEventOnPageUnload,
                                )}
                                gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
